import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { MultiBreaksPanelComponent } from './lib/multi-breaks-panel.component'
import { MultiBreaksKey } from './panel-key'

export const MultiBreaksPanelConfig: PanelConfig = {
  key: MultiBreaksKey,
  title: 'Breaks & Variances',
  description:
    'Address reconciliation breaks and variances. View details, change status, and add notes across multiple accounts',
  category: PanelCategory.ESSENTIALS,
  panelComponent: MultiBreaksPanelComponent,
  accessPermission: 'accessBreaksAndVariancesPanel',
  isExternal: true,
}
